import { Actions } from '#base/Canvas/Actions.js';
import { DesignerDispatch } from '#base/Canvas/Dispatch.js';
import classNames from 'classnames';
import React, { memo, useContext } from 'react';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

export function faceDisplayName(selectedFace: string) {
  if (selectedFace == 'logo') return 'FRONT';
  if (selectedFace == 'non-logo') return 'BACK';

  return selectedFace.toUpperCase();
}

const FacePagination = ({ config, selectedFace, className = '' }) => {
  // config should be sorted by face name
  const dispatch = useContext(DesignerDispatch);

  if (config && config.length <= 1) return null;

  const onPrevClick = () => {
    const currentFaceIdx = config.findIndex((c) => c.face === selectedFace);
    const nextFaceIdx = currentFaceIdx === 0 ? config.length - 1 : currentFaceIdx - 1;
    const nextFace = config[nextFaceIdx];
    dispatch(Actions.addFace(nextFace));
  };
  const onNextClick = () => {
    const currentFaceIdx = config.findIndex((c) => c.face === selectedFace);
    const nextFaceIdx = currentFaceIdx === config.length - 1 ? 0 : currentFaceIdx + 1;
    const nextFace = config[nextFaceIdx];
    dispatch(Actions.addFace(nextFace));
  };

  return (
    <div className='t-flex t-w-full t-justify-center'>
      <div
        onClick={onPrevClick}
        className={classNames('t-mt-5 t-inline-flex t-items-center t-gap-7', className)}>
        <div className='t-hidden t-cursor-pointer t-items-center t-justify-center t-transition t-duration-200 hover:t-opacity-80 lg:t-inline-flex'>
          <BsArrowLeft size={20} color='var(--plum-body-color)' />
        </div>
        <div className='t-inline-flex t-items-center t-gap-2'>
          {config.map((c, i) => {
            return (
              <span
                key={i}
                className={classNames(
                  't-inline-flex t-h-2 t-w-2 t-cursor-pointer t-items-center t-justify-center t-gap-1 t-rounded-full t-border t-border-brand-black t-transition',
                  {
                    't-bg-brand-black': c.face === selectedFace,
                  }
                )}
                onClick={() => dispatch(Actions.addFace(c))}></span>
            );
          })}
        </div>
        <div
          onClick={onNextClick}
          className='t-hidden t-cursor-pointer t-items-center t-justify-center t-transition t-duration-200 hover:t-opacity-80 lg:t-inline-flex'>
          <BsArrowRight size={20} color='var(--plum-body-color)' />
        </div>
      </div>
    </div>
  );
};

export default memo(FacePagination);
